import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import styles from './CollectionCardDropDown.scss'
import Popper from '@material-ui/core/Popper';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';

const CollectionCardDropDown = React.forwardRef((props, ref) => {
  const {
    open,
    onCloseHandler,
    onUpdate,
    onDelete,
    onShare,
    collectionName,
    showIcon = true
  } = props;

  return <Popper
    testid={'shareDropdown'}
    anchorEl={() => ref.current}
    open={open}
    onClose={onCloseHandler}
    placement="bottom-end"
  >
    <ClickAwayListener onClickAway={onCloseHandler}>
      <div className={styles.popoverContainer}>
        <CloseIcon
          testid={'collectionMenuCloseIcon'}
          fontSize={'medium'}
          onClick={onCloseHandler}
          className={styles.closeButton}
        />
        <div className={styles.popoverContentContainer}>
          <button onClick={onUpdate}>
            <span>Edit Collection Name</span>
          </button>
          <button style={{cursor: 'pointer'}} onClick={() => onShare()}>
            <span>Share Collection</span>
          </button>
          <button onClick={onDelete}>
            <span>Remove Collection</span>
          </button>
        </div>
      </div>

    </ClickAwayListener>

  </Popper>;
});

CollectionCardDropDown.propTypes = {
  open: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  collectionUuid: PropTypes.string,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onShare: PropTypes.func,
  collectionName: PropTypes.string,
};

export default CollectionCardDropDown;
